import React, { Suspense, lazy } from "react";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ScrollToTop from "../pages/ScrollToTop";

import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

import Home from "../pages/Home";

const About = lazy(() => import("../Components/About"));

const Products = lazy(() => import("../Components/products/Products"));

const ProcessSection = lazy(() => import("../Components/ProcessSection"));

const DeveloperCard = lazy(() => import("../Components/DeveloperCard"));

const ContactExport = lazy(() => import("../Components/ContactUS"));

const GstCertification = lazy(
  () => import("../Components/Certifications/GstCertification"),
);

function Loader() {
  return (
    <div className="page-loader">
      <div className="spinner"></div>
    </div>
  );
}

function Layout() {
  const location = useLocation();

  return (
    <>
      <ScrollToTop />

      {/* NAVBAR */}
      <Navbar />

      {/* ROUTES */}
      <Routes>
        <Route path="/" element={<Home />} />

        <Route
          path="/about"
          element={
            <Suspense fallback={<Loader />}>
              <About />
            </Suspense>
          }
        />

        <Route
          path="/products/:category"
          element={
            <Suspense fallback={<Loader />}>
              <Products />
            </Suspense>
          }
        />

        <Route
          path="/products"
          element={
            <Suspense fallback={<Loader />}>
              <Products />
            </Suspense>
          }
        />

        <Route
          path="/process"
          element={
            <Suspense fallback={<Loader />}>
              <ProcessSection />
            </Suspense>
          }
        />

        <Route
          path="/developer"
          element={
            <Suspense fallback={<Loader />}>
              <DeveloperCard />
            </Suspense>
          }
        />

        <Route
          path="/contact"
          element={
            <Suspense fallback={<Loader />}>
              <ContactExport />
            </Suspense>
          }
        />

        <Route
          path="/certifications"
          element={
            <Suspense fallback={<Loader />}>
              <GstCertification />
            </Suspense>
          }
        />
      </Routes>

      {/* FOOTER */}
      {location.pathname !== "/developer" && <Footer />}

      {/* TOAST */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        newestOnTop
        pauseOnHover
        draggable
        theme="dark"
      />

      {/* GLOBAL CSS */}
      <style>{`

        *{
          margin:0;
          padding:0;
          box-sizing:border-box;
        }

        html{
          scroll-behavior:smooth;
        }

        body{
          overflow-x:hidden;
          background:#ffffff;
          font-family:Poppins,sans-serif;

          text-rendering:optimizeSpeed;
          -webkit-font-smoothing:antialiased;
        }

        img{
          max-width:100%;
          display:block;
        }

        video{
          max-width:100%;
        }

        .page-loader{
          position:fixed;
          inset:0;
          z-index:9999;

          display:flex;
          justify-content:center;
          align-items:center;

          background:#ffffff;
        }

        .spinner{
          width:36px;
          height:36px;

          border-radius:50%;

          border:3px solid rgba(0,0,0,0.08);
          border-top:3px solid #3b82f6;

          animation:spin .7s linear infinite;
        }

        @keyframes spin{
          100%{
            transform:rotate(360deg);
          }
        }

        .Toastify__toast{
          border-radius:14px;
          min-height:55px;
          font-family:Poppins,sans-serif;
        }

        .Toastify__toast-body{
          display:flex;
          align-items:center;
          gap:10px;
        }

        .Toastify__close-button{
          background:transparent !important;
        }

      `}</style>
    </>
  );
}

function AppRoutes() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}

export default AppRoutes;
